import { mdiAccountMultipleOutline } from '@mdi/js'

export default {
  title: 'Student',
  to: 'student-headmaster-list',
  icon: mdiAccountMultipleOutline,
  resource: 'StudentHeadMaster',
  action: 'read',
}
